module.exports = __webpack_public_path__ + "img/SAFE.8ffece1b.svg";